"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DownloadQrCode = void 0;
var _components = require("@ori-ui/components");
var _logger = require("@ori/logger");
var _presentationHttp = require("@ori/presentation-http");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _useTranslations = require("../../hooks/useTranslations");
var _utils = require("../../utils");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const DownloadQrCode = () => {
  const logger = (0, _logger.useLogger)('DownloadQrCode');
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const {
    imageRef,
    gamificationActivityType
  } = (0, _contexts.useQrCodeDialog)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    createGamificationActivity
  } = (0, _presentationHttp.useCreateGamificationActivity)({
    activityType: gamificationActivityType
  });
  const onDownload = (0, _react.useCallback)(event => {
    event.preventDefault();
    if (!imageRef?.current) {
      return;
    }
    // The activity is created only for logged-in users, as per the createGamificationActivity implementation
    void createGamificationActivity();
    (0, _utils.downloadImageFromElement)({
      element: imageRef.current,
      fileName: (0, _utils.generateFileName)({
        prefix: 'qr-code',
        ext: 'png'
      })
    }).catch(error => logger.error(new Error('Error occurred while downloading QR code', {
      cause: error
    })));
  }, [createGamificationActivity, imageRef, logger]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
    fullWidth: true,
    "data-testid": getTestId(_constants.DOWNLOAD_QR_CODE),
    color: "primary",
    variant: "contained",
    onClick: onDownload,
    children: translations.downloadQrCode
  });
};
exports.DownloadQrCode = DownloadQrCode;
